// extracted by mini-css-extract-plugin
export default {"flex-div":"_flex-div_ZQbDQS","align-right":"_align-right_ouKgw-"};